import { apiFetcher } from '../api-fetcher';

type ReviewResponse = {
  data: {
    reviews: ReviewItem[];
    page:number;
    size:number;
    totalElements:number;
    totalPages:number;
    guide: {
      title:string;
      contents:string[];
    }
  }
  
}

export type ReviewParams = {
    page?:number;
    size?:number;
}
export type ReviewItem = {
    id:number;
    
    type:string;
    
    status:number;
    
    referrer?:string;
    
    referrerTxt?:string;
    
    fromBunpay:boolean; // deprecated
    
    grade:number;
    
    content:string;
    
    createdAt:string;
    
    modifiedAt:string;
    
    modifiedAtBefore:string;
    
    writerUid:number;
    
    writerProfileImage?:string;
    
    writerProfileImageCount:number;
    
    writerName:string;
    
    writerIsProshop:boolean;
    
    productId?:number;
    
    productName:string;
    
    productPrice:number;
    
    productImage?:string;
    images: {
            origin?:string;
            thumbnail: {   
            large?:string;            
            medium?:string;
            small?:string;
            }
    }[];
    originImages:string[]// {res}가 포함된 이미지 리스트
    imageMTime?:number;
    reply?:Reply;
    isDeleteActive:boolean;
    isModifyActive:boolean;
    isReplyActive:boolean;
    isReportActive:boolean;
    reportUrl:string;
    shopBadgeUrl?:string;
    keywords:string[];
    products:ReviewProductItem[];
    buntalkLastDate?:string;
    isBlind:boolean;
    imageCount:number;
    hasImage:boolean;
    hasReply:boolean;
}
type ReviewProductItem = {
  id:number;
  name:string;
  payAmount:number;
  image:string;
}

type Reply = {
    status:number;
    content:string;
    writerUid:number;
    writerName:string;
    writerProfileImage?:string;
    writerIsProshop:boolean;
    modifiedAt:string;
    modifiedAtBefore:string;
    isDeleteActive:boolean;
    isModifyActive:boolean;
    isReportActive:boolean;
    reportUrl:string;
    shopBadgeUrl?:string;
    isBlind:boolean;
}


export const getShopReviews = async (uid:number, params:ReviewParams) => {
  return apiFetcher.get<ReviewResponse>(`/api/review/v3/users/${uid}/reviews`, params);
};
